import {snakeCaseKeys} from 'Utility/commons/transformKeys';

export type User = {
  firstName: string;
  lastName: string;
  email: string;
  password: string;
  passwordConfirmation: string;
  profile: {
    firstName: string;
    lastName: string;
  };
};

export enum CardState {
  SIGN_IN = 'sign_in',
  SIGN_UP = 'sign_up',
}

export const registerUser = async (
  authenticityToken: string,
  signUpPath: string,
  user: User
): Promise<void> => {
  try {
    const response = await fetch(signUpPath, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': authenticityToken,
      },
      body: JSON.stringify({
        user: snakeCaseKeys(user),
      }),
    });

    if (!response.ok) {
      const data = await response.json();
      console.error('Registration response:', {
        status: response.status,
        statusText: response.statusText,
        data: data,
      });
      throw new Error(data.error || data.message || 'Registration failed');
    }

    window.location.href = response.url;
  } catch (error) {
    console.error('Registration error:', error);
    // Re-throw the error to be handled by the component
    throw error;
  }
};
